<template>
    <div>
        <ts-page-title
            :title="$t('dailyCoCashCloseOut.pageTitle')"
            :breadcrumb="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('dailyCoCashCloseOut.pageTitle'),
                    active: true
                }
            ]"
        />
        <ts-panel>
            <ts-panel-wrapper>
                <div class="row">
                    <div class="col-lg-3">
                        <div class="card border-0 bg-gray-900">
                            <div class="card-body">
                                <div class="text-gray-500">
                                    <b>{{
                                        $t("dailyCoCashCloseOut.filterCriteria")
                                    }}</b>
                                </div>
                            </div>
                            <div class="widget-list rounded-bottom">
                                <div class="mb-3 mt-3">
                                    <div class="col-md-12">
                                        <label
                                            class="form-col-label control-label"
                                            >{{
                                                $t("dailyCoCashCloseOut.branch")
                                            }}</label
                                        >
                                        <Select
                                            v-model="model.branch_id"
                                            filterable
                                            clearable
                                            :placeholder="
                                                $t('customer.typeToSearch')
                                            "
                                            :class="{
                                                'ivu-form-item-error': errors.has(
                                                    'branch_id'
                                                )
                                            }"
                                        >
                                            <Option
                                                v-for="(branch,
                                                index) in branches"
                                                :value="branch.branch_id"
                                                :key="index"
                                                :label="branch.branch_name_en"
                                            >
                                                {{ branch.branch_name_en }}
                                            </Option>
                                        </Select>
                                        <div
                                            class="text-danger"
                                            v-if="errors.has('branch_id')"
                                        >
                                            {{ errors.first("branch_id") }}
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div class="col-md-12">
                                        <label
                                            class="form-col-label control-label"
                                            >{{
                                                $t("dailyCoCashCloseOut.co")
                                            }}</label
                                        >
                                        <Select
                                            v-model="model.user_id"
                                            multiple
                                            :max-tag-count="1"
                                            :filterable="true"
                                            :filter-by-label="true"
                                            :placeholder="$t('all')"
                                        >
                                            <Option
                                                v-for="item in users"
                                                :value="item.user_id"
                                                :key="item.user_id"
                                                :label="
                                                    item.employee
                                                        .employee_name_en
                                                "
                                            >
                                                {{
                                                    item.employee
                                                        ? item.employee
                                                              .employee_name_en
                                                        : ""
                                                }}
                                            </Option>
                                        </Select>
                                        <div
                                            class="invalid-feedback"
                                            v-if="errors.has('user_id')"
                                        >
                                            {{ errors.first("user_id") }}
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <div class="col-md-12">
                                        <label
                                            class="form-col-label control-label"
                                            >{{
                                                $t(
                                                    "dailyCoCashCloseOut.transactionDate"
                                                )
                                            }}</label
                                        >
                                        <DatePicker
                                            :value="model.transaction_date"
                                            type="date"
                                            placeholder="Select Date"
                                            style="width:100%"
                                            @on-change="dateChange"
                                            :class="{
                                                'is-invalid': errors.has(
                                                    'transaction_date'
                                                )
                                            }"
                                        >
                                        </DatePicker>

                                        <div
                                            class="text-danger"
                                            v-if="errors.has('dateRange')"
                                        >
                                            {{ errors.first("dateRange") }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="mb-3 tw-justify-end tw-flex tw-space-x-2"
                                >
                                    <ts-button
                                        outline
                                        color="success"
                                        @click.prevent="exportExcel"
                                        :waiting="exporting"
                                    >
                                        <i
                                            class="far fa-file-excel"
                                            v-if="!exporting"
                                        ></i>
                                        {{ $t("exportExcel") }}</ts-button
                                    >
                                    <ts-button
                                        color="danger"
                                        outline
                                        @click.prevent="preview"
                                        :waiting="waiting"
                                    >
                                        <i
                                            class="far fa-file-pdf"
                                            v-if="!waiting"
                                        ></i>
                                        {{ $t("previewPdf") }}</ts-button
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-9">
                        <div id="container">
                            <ts-preview-pdf v-model="waiting" :src="src" />
                        </div>
                    </div>
                </div>
            </ts-panel-wrapper>
        </ts-panel>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import { debounce } from "lodash";
import moment from "moment";
import * as FileDownload from "downloadjs";
import { trim } from "lodash";

export default {
    name: "dailyCoCashCloseOut",
    data() {
        return {
            waiting: false,
            exporting: false,
            errors: new Errors(),
            src: "",
            model: {
                branch_id: null,
                user_id: null,
                transaction_date: moment().format("YYYY-MM-DD")
            }
        };
    },

    computed: {
        ...mapState("report/resource", ["users", "currencies", "branches"])
    },
    created() {
        this.getBranch();
        this.model.branch_id = this.$store.state.authUser.user.default_branch.branch_id;
    },
    methods: {
        ...mapActions("report/resource", ["getUserLogin","getBranch"]),
        preview() {
            this.errors = new Errors();
            this.waiting = true;
            this.src = "";
            this.$store
                .dispatch(
                    "report/creditOperation/dailyCoCashCloseOut",
                    this.model
                )
                .then(response => {
                    this.src = response.url;
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                    this.errors = new Errors(error.errors);
                })
                .finally(() => {
                    this.waiting = false;
                });
        },
        exportExcel() {
            this.errors = new Errors();
            this.exporting = true;

            this.$store
                .dispatch(
                    "report/creditOperation/dailyCoCashCloseOutExportExcel",
                    this.model
                )
                .then(response => {
                    let filename = trim(
                        response.headers["content-disposition"]
                            .substring(
                                response.headers["content-disposition"].indexOf(
                                    "filename"
                                )
                            )
                            .replace("filename=", ""),
                        '"'
                    );
                    FileDownload(response.data, filename);
                })
                .catch(err => {
                    let error = JSON.parse(
                        String.fromCharCode.apply(null, new Uint8Array(err))
                    );
                    this.notice({ type: "error", text: error.message });
                    this.errors = new Errors(error.errors);
                })
                .finally(() => (this.exporting = false));
        },
        dateChange(value) {
            this.model.transaction_date = value;
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "DAILY CO CASH CLOSEOUT",
                desc: not.text
            });
        }
    },
    watch: {
        "model.branch_id": debounce(function(value) {
            this.model.user_id = null;
            this.getUserLogin({
                branch_id: value
            });
        }, 500)
    }
};
</script>
